var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PartialNodeElement_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { GraphElement } from './graphElement';
import './toolConfig'; // force import for JsonSchemaV2
import { getToolInfo } from './toolConfigHelper';
import { partialNodeElementSchemaValidation } from '../validations.generated';
export const partialNodeElementSchema = {
    $id: 'urn:wisepipe-common-pipe:PartialNodeElement',
    type: 'object',
    properties: {
        x: { type: 'number', minimum: -100000, maximum: 100000 },
        y: { type: 'number', minimum: -100000, maximum: 100000 },
        nameOverride: { type: 'string' },
        color: { type: 'string', minLength: 7, maxLength: 7 },
        parentID: { oneOf: [{ type: 'string', uid: 10 }, { type: 'null' }] }
    },
    if: {
        required: ['config']
    },
    then: {
        properties: {
            config: { $ref: 'urn:wisepipe-common-pipe:ToolConfig' },
            toolType: { type: 'string', const: { $data: '1/config/toolType' } }
        }
    },
    else: {
        properties: {
            toolType: {
                type: 'string',
                // build a list of valid tooltypes, except ToolType.NONE
                enum: Object.keys(ToolType)
                    .map((key) => ToolType[key])
                    .filter((key) => typeof key !== 'function' && key !== ToolType.NONE)
            }
        }
    },
    required: ['toolType']
};
// This is a copy of NodeElement with optional x and y. PartialNodeElement is used for validating element updates
let PartialNodeElement = PartialNodeElement_1 = class PartialNodeElement extends GraphElement {
    constructor(elementID, toolType, x, y, config, lastModified, nameOverride, color, uniqueChangeID, parentID) {
        super(elementID, 'node', lastModified, uniqueChangeID);
        this.toolType = toolType;
        if (x !== undefined)
            this.x = x;
        if (y !== undefined)
            this.y = y;
        this.config = config;
        if (nameOverride !== undefined)
            this.nameOverride = nameOverride;
        if (color)
            this.color = color;
        this.parentID = parentID;
        JSON.validate(this, PartialNodeElement_1);
    }
    getName() {
        switch (this.toolType) {
            case ToolType.FILE:
                return this.nameOverride ? this.nameOverride : undefined;
            default:
                return this.nameOverride ? this.nameOverride : getToolInfo(this.toolType).displayName;
        }
    }
    static getToolNameForAuditLog(name, toolType) {
        if (name !== undefined)
            return name;
        // Element audit logs always need a name for the element
        // FILE type elements don't have a default name (until user override it), so we default to 'Data'
        if (toolType === ToolType.FILE)
            return 'Data';
        return toolType;
    }
    getToolNameForAuditLog() {
        return PartialNodeElement_1.getToolNameForAuditLog(this.getName(), this.toolType);
    }
};
PartialNodeElement = PartialNodeElement_1 = __decorate([
    JsonSchemaV2(partialNodeElementSchema, partialNodeElementSchemaValidation)
], PartialNodeElement);
export { PartialNodeElement };
//# sourceMappingURL=partialNodeElement.js.map